import { ReactElement, Fragment } from 'react';

import { RenderingField, RenderingFieldGroup } from '@zinnia/form-engine-sdk';

import { FieldFactory } from '../FieldFactory';
import { GridItem, SequenceNumber, VariantText } from './Styles/FieldVariantBStyles';
import { PdfPaddedGrid, ReactHtmlParser } from '@breathelife/ui-components';

type Props = {
  fieldGroup: RenderingFieldGroup;
};

export function FieldWrapperB(props: Props): ReactElement | null {
  const { fieldGroup } = props;

  fieldGroup.fields = fieldGroup.fields.filter((el) => el.visible);
  let subIndex = 0;
  return (
    <Fragment>
      <PdfPaddedGrid container direction='row'>
        {fieldGroup.title && (
          <GridItem item xs={9} padding={'0px 0px 10px 10px'}>
            <SequenceNumber>{`${fieldGroup.index}.`}</SequenceNumber>
            <VariantText>
              <ReactHtmlParser html={fieldGroup.title} />
            </VariantText>
          </GridItem>
        )}
        {fieldGroup.fields.map((field: RenderingField) => {
          if (typeof field.title !== 'undefined' && field.title !== '') subIndex++;
          return (
            <Fragment key={field.id}>
              <FieldFactory field={field} fieldIndex={`${fieldGroup.index}.${subIndex}. `} />
            </Fragment>
          );
        })}
      </PdfPaddedGrid>
    </Fragment>
  );
}
